/**
 * React calls whatever a useEffect returns as its clean-up when the page closes.
 * If anything (our code or a library) returns something that isn't a function —
 * null, a number, a promise — React throws "x is not a function" while leaving the
 * page, and the whole app goes blank. This drops such values (and says which effect
 * it was in the console) so leaving a page can never crash it.
 */
import * as ReactNS from "react";

const R = ReactNS.default || ReactNS;
let reported = 0;

function guard(name) {
  const original = R[name];
  if (typeof original !== "function" || original.__guarded) return;
  const wrapped = function (effect, deps) {
    if (typeof effect !== "function") return original(effect, deps);
    return original(function () {
      const out = effect();
      if (out === undefined || typeof out === "function") return out;
      if (reported++ < 5) console.warn(`[MetaTrack] ${name} returned ${out === null ? "null" : typeof out} instead of a clean-up function — ignored.`, String(effect).slice(0, 300));
      return undefined;
    }, deps);
  };
  wrapped.__guarded = true;
  try {
    R[name] = wrapped;
  } catch {
    /* frozen module object — nothing to do */
  }
}

guard("useEffect");
guard("useLayoutEffect");

export const effectGuardActive = () => R.useEffect.__guarded === true;
